const config = {
  rootUrl: process.env.REACT_APP_ROOT_URL || 'https://coolride-backend-189906eafdba.herokuapp.com'
};

export default config;
